<template>
  <div>
    <div v-show="!ready" class="text-xs-center" style="height:100vh">
      <v-progress-circular
        :size="200"
        style="margin:10%"
        :color="pageElements[$route.name].color"
        indeterminate
      ></v-progress-circular>
    </div>
    <div>
      <iframe
        v-show="ready"
        @load="loaded"
        style="height:100vh;width:100%;overflow:hidden;"
        :src="src"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      ready: false
    };
  },
  props: ["src"],
  methods: {
    loaded: function() {
      this.ready = true;
    }
  },
  computed: {
    ...mapGetters("common", {
      pageElements: "pageElements"
    })
  }
};
</script>

<style>
</style>
